import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {Room} from '../App';

const bull = (
    <Box
        component="span"
        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
        •
    </Box>
);

// we pass the room instance with type room

export default function BasicCard({ room }: { room: Room }) {
    return (
        // if cancelled is true we want to strike through the displayname and number
        // if newnumber is set we want to display the original number striked through with an arrow and the new number
        // if notice is defined we want to display it above the displayname
        <Card sx={{ minWidth: 275, m: '2rem' }}>
            <CardContent>
                {room.notice ? <Typography sx={{ fontSize: 30 }} color="text.secondary" gutterBottom>
                    {room.notice}
                </Typography> : null}


                <Typography variant="h4" sx={{ mb: 1.5 }} component="div">
                    {room.cancelled ? <s>{room.displayname}</s> : room.displayname}
                </Typography>
                <Typography sx={{ mb: 1.0 }} variant="h4" color="text.secondary">
                    {/*{room.cancelled ? <s>{room.number}</s> : room.number}*/}
                    {/*{room.newnumber ? <><s>{room.number}</s> <span>&#8594;</span> {room.newnumber}</> : null}*/}

                        {/*  First check if we have newnumber and if so striktrhough original and arrow to new. If is cancelled striketrhough this all  */}

                        {room.cancelled ? <s>{room.newnumber ? <><s>{room.number}</s> <span>&#8594;</span> {room.newnumber}</> : room.number}</s> : room.newnumber ? <><s>{room.number}</s> <span>&#8594;</span> {room.newnumber}</> : room.number}
                </Typography>
                <Typography variant="body2">

                </Typography>
            </CardContent>
        </Card>

    );
}